// @core/api/endpoints/document/update_document_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentTemplateResponse,
  UpdateDocumentTemplateRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Update template
 * Updates an existing document template. Supports partial updates via field mask.
 */
export async function UpdateDocumentTemplate(
  template_id: string,
  data: UpdateDocumentTemplateRequest,
  options?: RequestOptions
): Promise<DocumentTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.put<DocumentTemplateResponse>(requestPath, data, requestOptions);
}
